import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  createUrlTreeFromSnapshot,
  UrlSerializer,
} from '@angular/router';
import { DialogService } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { FatalErrorComponent } from '../global/components/fatal-error/fatal-error.component';
import {
  selectSettingsError,
  selectSettingsLoaded,
} from '../store/settings/settings.selectors';

export const settingsLoadGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
) => {
  const store = inject(Store);
  const dialog = inject(DialogService);
  const serializer = inject(UrlSerializer);

  return store.select(selectSettingsLoaded).pipe(
    filter((loaded) => loaded),
    switchMap(() => store.select(selectSettingsError)),
    map((err) => {
      if (!err) {
        return true;
      }

      dialog.open(FatalErrorComponent, {
        closeButton: false,
        enableClose: false,
        data: {
          url: serializer.serialize(createUrlTreeFromSnapshot(next, ['.'])),
        },
      });

      return false;
    }),
  );
};
